var app = angular.module('leonardo');

var LinkDirective = function(ConfigThemeService) {
  return {
    restrict: 'C',
    scope: {
      linkColor: '@'
    },
    link: function (scope, element) {

      scope.setColor = function() {
        var color = scope.linkColor ? ConfigThemeService.getColor(scope.linkColor) : ConfigThemeService.config.theme_config.secondaryColor;
        element.css('color', color);
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('link', ['ConfigThemeService', LinkDirective]);
